import script from "./DescriptionBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptionBlock.vue?vue&type=script&setup=true&lang=js"

import "./DescriptionBlock.vue?vue&type=style&index=0&id=69c26fc4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c26fc4"]])

export default __exports__